import(/* webpackMode: "eager" */ "/home/danielwong/facility-calcom/cal2/apps/web/app/(use-page-wrapper)/(main-nav)/availability/error.tsx");
